import React from "react";

/**
 * AmbientMotion
 * Cinematic, almost-imperceptible motion layer for the whole site.
 *   - Soft drifting "warm light" gradients
 *   - A few slow-moving dust motes
 *   - Disabled automatically for users with prefers-reduced-motion
 *
 * Pointer-events disabled so it never blocks interaction.
 */
export default function AmbientMotion() {
  return (
    <div
      aria-hidden="true"
      data-testid="ambient-motion"
      className="ambient-layer fixed inset-0 pointer-events-none z-[1] overflow-hidden"
    >
      {/* Two extremely slow warm-light blobs drifting across the page */}
      <div className="ambient-blob ambient-blob-a" />
      <div className="ambient-blob ambient-blob-b" />

      {/* A handful of dust motes — very faint */}
      {Array.from({ length: 9 }).map((_, i) => (
        <span key={i} className={`mote mote-${i + 1}`} />
      ))}
    </div>
  );
}
